import { useEffect, useRef, useState } from "react";

export const GoldLogo = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="wcs-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#B8860B" />
        <stop offset=".45" stopColor="#F5D77A" />
        <stop offset=".7" stopColor="#D4AF37" />
        <stop offset="1" stopColor="#9A7B2F" />
      </linearGradient>
    </defs>
    <rect width="64" height="64" rx="16" fill="#0A0A0A" />
    <rect x="1.5" y="1.5" width="61" height="61" rx="14.5" fill="none" stroke="url(#wcs-g)" strokeWidth="2" />
    <path d="M14 22l8 22 10-16 10 16 8-22" fill="none" stroke="url(#wcs-g)" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="32" cy="15" r="5" fill="url(#wcs-g)" />
  </svg>
);

export function useInViewOnce(amount = 0.12) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) { setInView(true); return undefined; }
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setInView(true); io.disconnect(); }
    }, { threshold: amount });
    io.observe(el);
    return () => io.disconnect();
  }, [amount]);
  return [ref, inView];
}

export const Reveal = ({ children, delay = 0, className = "", as: Tag = "div", ...rest }) => {
  const [ref, inView] = useInViewOnce();
  return (
    <Tag ref={ref} className={`reveal ${inView ? "is-in" : ""} ${className}`} style={{ transitionDelay: `${delay}ms` }} {...rest}>
      {children}
    </Tag>
  );
};

export const Container = ({ children, className = "" }) => (
  <div className={`mx-auto w-full max-w-6xl px-5 sm:px-8 ${className}`}>{children}</div>
);

export const Label = ({ children, className = "" }) => (
  <p className={`label-xs text-[#D4AF37] ${className}`}>{children}</p>
);

export const SectionTitle = ({ eyebrow, children, className = "", testid, center }) => (
  <Reveal className={`mb-12 sm:mb-16 ${center ? "text-center" : ""} ${className}`}>
    {eyebrow && <Label className="mb-4">{eyebrow}</Label>}
    <h2 data-testid={testid} className="f-cinzel text-[30px] font-bold leading-[1.15] text-[#F5F0E6] sm:text-4xl lg:text-5xl">
      {children}
    </h2>
    <div className={`gold-rule mt-6 w-28 ${center ? "mx-auto" : ""}`} />
  </Reveal>
);
